import { useCallback } from 'react';
import { useLingui } from '@lingui/react';

import { resolveApiErrorMessage } from '@rover/utilities/apiErrorMessage';

/** Takes an `ApiErrorMessage`, a caught error, or nothing, which resolves to `''`. */
export type ResolveApiErrorMessage = (value: unknown) => string;

/**
 * Turns the unresolved reason an api call failed into text, using the request's `i18n`, which
 * a duck has no access to.
 */
export const useResolveApiErrorMessage = (): ResolveApiErrorMessage => {
  const { i18n } = useLingui();

  return useCallback((value) => resolveApiErrorMessage(value, i18n), [i18n]);
};

export default useResolveApiErrorMessage;
